module.exports = __webpack_public_path__ + "img/Gapp-logo-dark.51b78098.png";